import { createSlice } from '@reduxjs/toolkit';
import { addNewOrganization, editOrganization, getAllOrganizations } from './organizationService';

const initialState = {
  allOrganizations: {
    isOrganizationsLoading: null,
    isOrganizationsSuccess: null,
    organizationsMessage: null,
    pageCount: 0,
    organizations: [],
  },
  newOrganization: {
    isOrganizationCreating: null,
    isOrganizationCreated: null,
    organizationCreationMsg: null,
  },

  editedOrganization: {
    isEditingOrganization: null,
    isOrganizationEdited: null,
    organizationEditedMsg: null
  }
};

const organizationsSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllOrganizations.pending, (state) => {
        state.allOrganizations = {
          ...initialState.allOrganizations, // Reset to initial state
          isOrganizationsLoading: true,
          organizationsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllOrganizations.rejected, (state, action) => {
        state.allOrganizations = {
          ...initialState.allOrganizations,
          isOrganizationsLoading: false,
          isOrganizationsSuccess: false,
          organizationsMessage: action.payload || 'Error occurred while fetching organizations',
        };
      })

      // FULFILLED
      .addCase(getAllOrganizations.fulfilled, (state, action) => {
        state.allOrganizations = {
          ...initialState.allOrganizations,
          isOrganizationsLoading: false,
          isOrganizationsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          organizations: action.payload || [],
        };
      });

    //Organization creating
    builder
      .addCase(addNewOrganization.pending, (state) => {
        state.newOrganization = {
          ...initialState.newOrganization, // Reset to initial state
          isOrganizationCreating: true,
          organizationCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewOrganization.rejected, (state, action) => {
        state.newOrganization = {
          ...initialState.newOrganization,
          isOrganizationCreating: false,
          isOrganizationCreated: false,
          organizationCreationMsg: action.payload || 'Error occurred while creating the organization.',
        };
      })

      // FULFILLED
      .addCase(addNewOrganization.fulfilled, (state, action) => {
        state.newOrganization = {
          ...initialState.newOrganization,
          isOrganizationCreating: false,
          isOrganizationCreated: true,
          organizationCreationMsg: action.payload || 'Successfully created the organization.',
        };
      });

    //Organization editing
    builder
      .addCase(editOrganization.pending, (state) => {
        state.editedOrganization = {
          ...initialState.editedOrganization, // Reset to initial state
          isEditingOrganization: true,
          organizationEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editOrganization.rejected, (state, action) => {
        state.editedOrganization = {
          ...initialState.editedOrganization, // Reset to initial state
          isEditingOrganization: false,
          isOrganizationEdited: false,
          organizationEditedMsg: action.payload || 'Error occurred while editing the organization.',
        };
      })

      // FULFILLED
      .addCase(editOrganization.fulfilled, (state, action) => {
        state.editedOrganization = {
          ...initialState.editedOrganization, // Reset to initial state
          isEditingOrganization: false,
          isOrganizationEdited: true,
          organizationEditedMsg: action.payload || 'Successfully edited the organization.',
        };
      });
  },
});

export default organizationsSlice.reducer;
